import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "overlay"]

  connect() {
    console.log("InlineSidebarController connected")

    // Listen for successful form submissions
    document.addEventListener('turbo:submit-end', this.handleFormSubmit.bind(this))

    // Add logging for Turbo Frame events
    document.addEventListener('turbo:frame-load', this.logFrameLoad.bind(this))
    // document.addEventListener('turbo:before-frame-render', this.logBeforeFrameRender.bind(this))
    // document.addEventListener('turbo:before-fetch-request', this.logBeforeFetchRequest.bind(this))
    // document.addEventListener('turbo:fetch-request-error', this.logFetchRequestError.bind(this))
  }

  disconnect() {
    document.removeEventListener('turbo:submit-end', this.handleFormSubmit.bind(this))
    document.removeEventListener('turbo:frame-load', this.logFrameLoad.bind(this))
    // document.removeEventListener('turbo:before-frame-render', this.logBeforeFrameRender.bind(this))
    // document.removeEventListener('turbo:before-fetch-request', this.logBeforeFetchRequest.bind(this))
    // document.removeEventListener('turbo:fetch-request-error', this.logFetchRequestError.bind(this))
  }

  logFrameLoad(event) {
    console.log("Turbo frame loaded:", event.target)
    if (event.target.id === "sidebar_content") {
      console.log("Turbo frame loaded:", event.target)

      // Ensure the sidebar is open once content is loaded
      this._openSidebar()
    }
  }

  logBeforeFrameRender(event) {
    console.log("Before turbo frame render:", event.detail)
    if (event.target.id === "sidebar_content") {
      console.log("Before turbo frame render:", event.detail)
    }
  }

  // logBeforeFetchRequest(event) {
  //   console.log("Before fetch request:", event.detail.url, event.detail.fetchOptions)
  // }

  // logFetchRequestError(event) {
  //   console.error("Fetch request error:", event.detail.error, event.detail.request.url)
  // }

  open(event) {
    console.log("Sidebar open method called", event)

    if (event) {
      event.preventDefault()

      // We need to let the click event complete and the Turbo request start
      // before we open the sidebar
      setTimeout(() => {
        this._openSidebar()
      }, 10)
    } else {
      this._openSidebar()
    }
  }

  _openSidebar() {
    const container = this.containerTarget
    const overlay = this.overlayTarget

    // Show the elements first
    container.classList.remove('hidden')
    overlay.classList.remove('hidden')

    // Force a reflow to ensure the transition works
    void container.offsetWidth
    void overlay.offsetWidth

    // Animate in from right
    container.classList.remove('translate-x-full')
    overlay.classList.remove('opacity-0')
    overlay.classList.add('opacity-100')

    // Prevent body scrolling
    document.body.classList.add('overflow-hidden')
  }

  close(event) {
    if (event) {
      event.preventDefault()
    }
    console.log("Sidebar close method called", event)

    const container = this.containerTarget
    const overlay = this.overlayTarget

    // Animate out to right
    container.classList.add('translate-x-full')
    overlay.classList.remove('opacity-100')
    overlay.classList.add('opacity-0')

    // Re-enable body scrolling
    document.body.classList.remove('overflow-hidden')

    // Hide after transition
    setTimeout(() => {
      container.classList.add('hidden')
      overlay.classList.add('hidden')

      // Clear the sidebar content after closing
      const frame = document.getElementById('sidebar_content')
      if (frame) {
        frame.innerHTML = ''
      }
    }, 300)
  }

  closeOnOverlay(event) {
    // Only respond to direct clicks on the overlay
    if (event.target === this.overlayTarget) {
      this.close()
    }
  }

  handleFormSubmit(event) {
    // Only close the sidebar if the form was submitted     
    if (event.detail.success) {
      setTimeout(() => this.close(), 300)
    }
  }
} 